export default "__VITE_ASSET__BQ6aMq2H__"